/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const JBP_DIRECT_REPORT_EXECUTION_FRAGMENT = gql`
  fragment JBPExecutionByDirectReport on JBPExecutionByDirectReport {
    id
    name
    coldVaultComplianceNumerator
    coldVaultComplianceDenominator
    auditQuestionComplianceNumerator
    auditQuestionComplianceDenominator
    numStores
    numAuditedStores
    combinedComplianceNumerator
    combinedComplianceDenominator
  }
`
